const TypePill = ({ label, icon, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl border-2 text-sm font-semibold transition-all ${
      active
        ? "border-blue-700 text-blue-700 bg-blue-50 dark:border-blue-500 dark:text-blue-400 dark:bg-blue-900/30"
        : "border-gray-200 text-gray-500 bg-white hover:border-blue-200 hover:bg-blue-50/40 dark:border-gray-700 dark:text-gray-400 dark:bg-gray-800 dark:hover:border-blue-700/50 dark:hover:bg-blue-900/20"
    }`}
  >
    {icon}
    {label}
  </button>
);

export default TypePill;
